import { ChangeDetectorRef, OnDestroy, Pipe, PipeTransform } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { State } from 'src/app/store';
import { NavigationItem } from '../../global.model';
import { secondaryNavigationItemsSelector } from '../../store/global.selectors';

/**
 * Usage: {{ 'fallback.translation.key' | secondaryNavTitle }}
 * Impure so it re-evaluates on navigation, since router.url isn't an input.
 */
@Pipe({
    name: 'secondaryNavTitle',
    pure: false,
})
export class SecondaryNavTitlePipe implements PipeTransform, OnDestroy {
    private items: NavigationItem[] = [];

    private subscription: Subscription;

    constructor(
        private store: Store<State>,
        private router: Router,
        private translate: TranslateService,
        private cdr: ChangeDetectorRef,
    ) {
        this.subscription = this.store.select(secondaryNavigationItemsSelector).subscribe((items) => {
            this.items = items ?? [];
            this.cdr.markForCheck();
        });
    }

    transform(fallbackTranslationKey: string): string {
        const topLevelPath = `/${this.router.url.split('?')[0].split('#')[0].split('/')[1] ?? ''}`;
        const match = this.items.find((item) => item.path === topLevelPath);
        return match?.text ?? this.translate.instant(fallbackTranslationKey);
    }

    ngOnDestroy(): void {
        this.subscription?.unsubscribe();
    }
}
